{
  "version": 1,
  "asset_id": "cb277ffb-a566-4723-af62-4a3d6549f310",
  "project_id": "8f4e0cb3-546d-4528-9687-8899f14664d6",
  "url": "/__l5e/assets-v1/cb277ffb-a566-4723-af62-4a3d6549f310/ia-hostelearte.png",
  "r2_key": "a/v1/8f4e0cb3-546d-4528-9687-8899f14664d6/cb277ffb-a566-4723-af62-4a3d6549f310/ia-hostelearte.png",
  "original_filename": "ia-hostelearte.png",
  "size": 343813,
  "content_type": "image/png",
  "created_at": "2026-11-05T15:14:34Z"
}
